import React from "react";
import styles from "./DetailsContainer.module.css";
import { CategoryBlock, TextBlock } from "..";
import { translate } from "../../../../../providers";

function flattenValues(values) {
	const result = [];
	function recurse(items) {
		for (const item of items) {
			const { subThematic, ...rest } = item;
			if (rest.matched) {
				result.push(rest);
			}
			if (subThematic) {
				recurse(subThematic);
			}
		}
	}

	recurse(values);
	return result;
}

const DetailsContainer = ({
	deliverableName,
	parentRequirement = null,
	isEditing = false,
	onUpdateChildrenRequirement,
	updatedChildrenRequirement,
}) => {
	const getReqIdStringValue = () => {
		let newId = `${updatedChildrenRequirement?.id}-${updatedChildrenRequirement?.informationId}`;
		if (updatedChildrenRequirement?.informationRef) {
			newId = `${newId}(${updatedChildrenRequirement?.informationRef})`;
		}
		return newId;
	};
	return (
		<div className={styles.container}>
			<div className={styles.innerContainer} data-has-parent-details={!!parentRequirement}>
				{!!parentRequirement && (
					<div className={styles.innerContainer__title}>
						{translate("common:children-requirements.child-requirement-details")}
					</div>
				)}
				<div className={styles.innerContainer__details}>
					<TextBlock
						title={translate("common:children-requirements.requirement-id")}
						value={getReqIdStringValue()}
					/>
					<TextBlock
						title={translate("common:children-requirements.requirement-description")}
						value={updatedChildrenRequirement?.content}
					/>
					<CategoryBlock
						elements={updatedChildrenRequirement?.themes || []}
						identifier="theme"
						isEditing={isEditing}
						title={translate("common:children-requirements.theme")}
						values={flattenValues(updatedChildrenRequirement?.themes || [])}
						onChange={onUpdateChildrenRequirement}
					/>
					<CategoryBlock
						elements={updatedChildrenRequirement?.locations || []}
						identifier="location"
						isEditing={isEditing}
						title={translate("common:children-requirements.location")}
						values={flattenValues(updatedChildrenRequirement?.locations || [])}
						onChange={onUpdateChildrenRequirement}
					/>
					<TextBlock
						title={translate("common:children-requirements.design-document")}
						value={deliverableName}
					/>
					<TextBlock
						title={translate("common:children-requirements.chapter-title")}
						value={updatedChildrenRequirement?.title}
					/>
					<CategoryBlock
						elements={updatedChildrenRequirement?.methodValidation || []}
						identifier="method"
						isEditing={isEditing}
						title={translate("common:children-requirements.method-validation")}
						values={flattenValues(updatedChildrenRequirement?.methodValidation || [])}
						onChange={onUpdateChildrenRequirement}
					/>
					<CategoryBlock
						elements={updatedChildrenRequirement?.phaseValidation || []}
						identifier="phase"
						isEditing={isEditing}
						title={translate("common:children-requirements.phase-validation")}
						values={flattenValues(updatedChildrenRequirement?.phaseValidation || [])}
						onChange={onUpdateChildrenRequirement}
					/>
				</div>
			</div>
			{!!parentRequirement && (
				<div className={styles.innerContainer} data-has-parent-details={!!parentRequirement}>
					<div className={styles.innerContainer__title}>
						{translate("common:children-requirements.linked-parednt-details")}
					</div>
					<div className={styles.innerContainer__details}>
						<TextBlock
							title={translate("common:children-requirements.source-document")}
							value={parentRequirement.documentName}
						/>
						<TextBlock
							title={translate("common:children-requirements.chapter")}
							value={parentRequirement.clause}
						/>
						<TextBlock
							title={translate("common:children-requirements.parent-requirement-id")}
							value={parentRequirement.reqId || parentRequirement.informationId}
						/>
						<TextBlock
							title={translate("common:children-requirements.parent-requirement-description")}
							value={parentRequirement.content}
						/>
						<TextBlock
							title={translate("common:enum.params.negotiability")}
							value={
								parentRequirement.type === "INFORMATION"
									? translate("common:enum.filters.content-type.information")
									: translate("common:enum.filters.content-type.requirement")
							}
						/>
					</div>
				</div>
			)}
		</div>
	);
};

export default DetailsContainer;
